"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecaptcha = useRecaptcha;

var _react = _interopRequireWildcard(require("react"));

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Module dependencies.
 */

/**
 * Export `useRecaptcha`.
 */
function useRecaptcha({
  onSubmit,
  recaptchaSiteKey
}) {
  const ref = (0, _react.useRef)();
  const submitRef = (0, _react.useRef)(onSubmit);
  const [isExecuting, setExecuting] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    submitRef.current = onSubmit;
  });
  const renderRecaptcha = (0, _react.useCallback)(() => /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    ref: ref,
    sitekey: recaptchaSiteKey,
    size: 'invisible'
  }), [recaptchaSiteKey]);
  const submitWithRecaptcha = (0, _react.useCallback)(async values => {
    if (!recaptchaSiteKey || !ref.current) {
      return onSubmit(values);
    }

    setExecuting(true);
    const recaptchaToken = await ref.current.executeAsync();

    try {
      return await onSubmit({ ...values,
        'g-recaptcha-response': recaptchaToken
      });
    } finally {
      setExecuting(false);
      ref.current.reset();
    }
  }, [onSubmit, recaptchaSiteKey]);
  return {
    isRecaptchaExecuting: isExecuting,
    renderRecaptcha,
    submitWithRecaptcha
  };
}